import { render } from "./Shop.vue?vue&type=template&id=11a5ec7c&scoped=true&ts=true"
import script from "./Shop.vue?vue&type=script&lang=ts"
export * from "./Shop.vue?vue&type=script&lang=ts"

import "./Shop.vue?vue&type=style&index=0&id=11a5ec7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a5ec7c"]])

export default __exports__